import chartIcon from '@material-ui/icons/ShowChart';
import ChartList from './ChartList';

export default {
    list: ChartList,
    icon: chartIcon,
};
